import { render, staticRenderFns } from "./ChaveSegurancaNovo.vue?vue&type=template&id=38f9390c"
import script from "./ChaveSegurancaNovo.vue?vue&type=script&lang=js"
export * from "./ChaveSegurancaNovo.vue?vue&type=script&lang=js"
import style0 from "./ChaveSegurancaNovo.vue?vue&type=style&index=0&id=38f9390c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports